import 'react-toastify/dist/ReactToastify.css';

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import { UserPopover } from "./Userpopover";
import { usePopover } from "../utils/customHooks";
import { Logo } from "./Logo";
import { useTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { getSessionTimeLeft, sessionTimingAction } from "../store/sessionTiming/sessionTimingSlice";
import calendarSvg from '../assets/svgs/headerIcons/calender.svg';
import redClockSvg from '../assets/svgs/headerIcons/redClock.svg';
import dropdownSvg from '../assets/svgs/headerIcons/dropdown.svg';
import btnSideSvg from '../assets/svgs/menuIcons/btnSide.svg';
import btnSide2Svg from '../assets/svgs/menuIcons/btnSide2.svg';
import { Typography } from '@mui/material';
import useAuth from '../pages/login/hooks';
import { useProfile } from '../pages/profile/hooks';

const formatRoleLabel = (role) => {
    if (!role) return '';
    return role
        .toString()
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

export default function Header({ onToggleNav, navCollapsed }) {
    const dispatch = useDispatch();
    const { detail } = useAuth();
    const { profile } = useProfile();
    const timeLeft = useSelector(getSessionTimeLeft);
    const [openNav, setOpenNav] = React.useState(false);
    const [toastShown, setToastShown] = React.useState(false);
    const userPopover = usePopover();
    const theme = useTheme();
    const navigate = useNavigate();
    const selectedPopover = (type) => {
        if (type === 'profile') {
            navigate("/profile")
        }
        userPopover.handleClose()
    }

    // Resume session timer on page load if there's a stored end time
    const sessionTimerResumed = React.useRef(false);
    React.useEffect(() => {
        if (!sessionTimerResumed.current && detail && detail?.roles?.[0]?.role === "STUDENT" && timeLeft > 0) {
            sessionTimerResumed.current = true;
            dispatch(sessionTimingAction.startSessionTimer());
        }
    }, [detail, timeLeft]);

    React.useEffect(() => {
        if (detail && detail?.roles?.[0]?.role === "STUDENT") {
            if (timeLeft <= 5 * 60 && timeLeft > 0 && !toastShown) {
                toast.warn("Less than 5 minutes remaining!");
                setToastShown(true);
            }
        }
    }, [timeLeft, toastShown]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };

    const getCurrentTime = () => {
        const days = ["Sun", "Mon", "Tues", "Wed", "Thu", "Fri", "Sat"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const now = new Date();

        const dayName = days[now.getDay()];
        // let hours = now.getHours();
        // const minutes = now.getMinutes();

        // const ampm = hours >= 12 ? 'PM' : 'AM';
        // hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format, 0 to 12

        // return `${dayName}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
        const day = now.getDate();
        const monthName = months[now.getMonth()];
        const year = now.getFullYear();

        return `${dayName} ${day} ${monthName} ${year}`;
    }

    return (
        <React.Fragment>
            <Box
                component="header"
                sx={{
                    // borderBottom: "1px solid var(--mui-palette-primary-main)",
                    backgroundColor: "var(--mui-palette-background-headerbg)",
                    position: "sticky",
                    top: 0,
                    zIndex: "var(--mui-zIndex-appBar)",
                    boxShadow: '0px 4px 4px 0px #00000040'
                }}
            >
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        alignItems: "center",
                        justifyContent: "space-between",
                        minHeight: "65px",
                        px: 2,
                        [theme.breakpoints.down('sm')]: {
                            p: 1,
                        },
                    }}
                >
                    <Box sx={{
                        display: "inline-flex",
                        alignItems: 'center',
                        gap: '20px',
                        pt: 0.1,
                        [theme.breakpoints.down('sm')]: {
                            width: '100%',
                            display: 'flex',
                            justifyContent: "space-between",
                        },
                    }}>
                        <Box sx={{
                            // marginLeft: '20px',
                            [theme.breakpoints.down('sm')]: {
                                // width: '100%',
                                textAlign: 'center',
                                margin: '0 10px'
                            }

                        }}>
                            <Logo color="light" height={40} width={100} />
                        </Box>
                        <Box sx={{
                            display: 'flex', alignItems: 'center'
                        }}>
                            <Box sx={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 10px', gap: '10px', cursor: "pointer", ml: 2,
                                [theme.breakpoints.up('sm')]: {
                                    display: 'none', // Hide Stack on smaller screens
                                }
                            }} onClick={userPopover?.handleOpen}
                                ref={userPopover?.anchorRef}>
                                <Avatar
                                    src={profile?.gender === "MALE" ? '../assets/images/boykid.jpeg' : '../assets/images/girlkid.jpeg'}
                                    sx={{
                                        border: '2px solid #FFFFFF', boxShadow: '0px 4px 4px 0px #0000000A'
                                    }}
                                />
                            </Box>
                            <IconButton onClick={onToggleNav}
                                sx={{
                                    color: 'var(--mui-palette-primary-blue)',
                                    px: 1,
                                    py: 0,
                                    mb: 1
                                }}>
                                {navCollapsed ? <img style={{ width: '70%' }} src={btnSideSvg} alt="" /> : <img style={{ width: '70%' }} src={btnSide2Svg} alt="" />}
                            </IconButton>
                        </Box>
                    </Box>

                    <Stack
                        sx={{
                            alignItems: "center",
                            [theme.breakpoints.down('sm')]: {
                                width: '100%',
                                display: 'none', // Hide Stack on smaller screens
                                marginLeft: '0 !important',
                            }
                        }}
                        direction="row"
                    >
                        <Tooltip title="">
                            <Badge >
                                {/* <IconButton
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                    }}> */}
                                <img style={{ width: '15%', marginTop: 2 }} src={calendarSvg} alt="" />
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: '"Quicksand", sans-serif',
                                        color: 'var(--mui-palette-action-active)',
                                        cursor: 'default'
                                    }}
                                >
                                    {getCurrentTime()}
                                </Typography>
                                {/* </IconButton> */}
                            </Badge>
                        </Tooltip>
                        {detail && detail?.roles?.[0]?.role === "STUDENT" && timeLeft > 0 &&
                            <Tooltip title="Session Timing">
                                <Badge >
                                    <IconButton
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}>
                                        <img style={{ width: '25%', marginTop: 2 }} src={redClockSvg} alt="" />
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontFamily: '"Quicksand", sans-serif',
                                            }}
                                        >
                                            {formatTime(timeLeft)}
                                        </Typography>
                                        {/* <ClockCountdown /> */}
                                    </IconButton>
                                </Badge>
                            </Tooltip>
                        }
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 10px', gap: '10px', cursor: "pointer", ml: 2, }} onClick={userPopover?.handleOpen}
                            ref={userPopover?.anchorRef}>
                            <Avatar
                                src={profile?.gender === "MALE" ? '../assets/images/boykid.jpeg' : '../assets/images/girlkid.jpeg'}
                                sx={{
                                    border: '2px solid #FFFFFF', boxShadow: '0px 4px 4px 0px #0000000A'
                                }}
                            />
                            <Box sx={{ padding: '5px 0', position: 'relative' }}>
                                <Typography sx={{
                                    fontWeight: 400,
                                    fontFamily: '"Quicksand", sans-serif',
                                    fontSize: '0.7em',
                                    textAlign: 'left'
                                }}>
                                    Hi Welcome,
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 600,
                                    fontFamily: '"Quicksand", sans-serif',
                                    fontSize: '0.75em',
                                    textAlign: 'right'
                                }}>
                                    {Object.keys(profile).length > 0 ? `${profile?.firstName} ${profile?.lastName}` : `${detail?.firstName} ${detail?.lastName}`}
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 400,
                                    fontFamily: '"Quicksand", sans-serif',
                                    fontSize: '0.65em',
                                    textAlign: 'right'
                                }}>
                                    {profile?.gradeLevel || profile?.grade || formatRoleLabel(profile?.academicStaffProfile || detail?.roles?.[0]?.role)}
                                </Typography>
                                <img style={{ width: '10%', position: 'absolute', top: '24px', right: '-10px' }} src={dropdownSvg} alt="" />
                            </Box>
                        </Box>

                    </Stack>
                </Stack>
            </Box>
            <UserPopover selectedPopover={selectedPopover} anchorEl={userPopover?.anchorRef?.current} onClose={userPopover?.handleClose} open={userPopover?.open} />

        </React.Fragment>
    );
}